import * as RxDialog from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { ReactNode } from 'react';

import Text from '../base/Text';
import CrossIcon from '../icons/CrossIcon';
import Button from '../input/Button';
import './Dialog.css';

export default function PlayerDialog({
  title,
  children,
  maxWidth,
  open = true,
  close,
  zValue = 10,
  alignMobile = 'center',
}: {
  title?: string;
  children: ReactNode;
  maxWidth?: number;
  open?: boolean;
  close?: () => void;
  zValue?: number;
  alignMobile?: 'center' | 'start' | 'end';
}) {
  return (
    <RxDialog.Root open={open} modal={false}>
      <div
        className={`pointer-events-none absolute inset-4 bottom-24 flex justify-center md:items-center lg:inset-16 ${
          alignMobile === 'start'
            ? 'items-start'
            : alignMobile === 'end'
              ? 'items-end'
              : 'items-center'
        }`}
        style={{
          zIndex: zValue,
        }}
      >
        <RxDialog.Content
          className="dark:bg-gray-90 shadow-menu focus:outline-hidden pointer-events-auto relative max-h-[85vh] w-fit rounded-2xl bg-white"
          style={{ maxWidth }}
        >
          {title ? (
            <RxDialog.Title className="flex flex-none px-6 pt-6">
              <Text variant="studio/title/lg">{title}</Text>
            </RxDialog.Title>
          ) : (
            <VisuallyHidden asChild>
              <RxDialog.Title>Dialog window</RxDialog.Title>
            </VisuallyHidden>
          )}
          <VisuallyHidden asChild>
            <RxDialog.Description>
              This dialog contains additional content.
            </RxDialog.Description>
          </VisuallyHidden>
          <div className="p-8 text-center dark:text-white">{children}</div>
          {close && (
            <RxDialog.Close asChild>
              <Button
                variant="tertiary"
                icon={<CrossIcon />}
                aria-label="Close"
                className="absolute right-2.5 top-2.5"
                onClick={close}
              />
            </RxDialog.Close>
          )}
        </RxDialog.Content>
      </div>
    </RxDialog.Root>
  );
}
